export type GeneratorAttachedFile = {
  /** SHA-256 hex of raw file bytes */
  id: string;
  name: string;
  mimeType: string;
  size: number;
  dataBase64: string;
};

export type GeneratorAttachedFileApiPayload = {
  name: string;
  mime_type: string;
  size: number;
  data_base64: string;
};

export const GENERATOR_MAX_FILES = 10;
export const GENERATOR_MAX_FILE_BYTES = 10 * 1024 * 1024;
export const GENERATOR_MAX_TAB_BYTES = 50 * 1024 * 1024;

export const GENERATOR_ACCEPTED_MIME_TYPES = [
  'application/pdf',
  'text/plain',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
] as const;

export type GeneratorAcceptedMimeType = (typeof GENERATOR_ACCEPTED_MIME_TYPES)[number];

export function toApiAttachedFile(file: GeneratorAttachedFile): GeneratorAttachedFileApiPayload {
  return {
    name: file.name,
    mime_type: file.mimeType,
    size: file.size,
    data_base64: file.dataBase64,
  };
}
